import React from "react";

function LeftComponent(props) {
  return (
    <>
      <div className="bs-offset-main bs-canvas-anim">{props.children}</div>
    </>
  );
}

export default LeftComponent;
